module.exports = __webpack_public_path__ + "static/UnclickTravelAssistanceYellow-037c128dcd68d2b58a65e70849f44fc1.png";